/**
 * Espelha CompartilharVendaRequest do OrquestradorVendas: gera o link público do documento e envia
 * o e-mail ao destinatário. O documento vai na rota.
 */
export class CompartilharVendaRequest {
    /** Validade do link em dias: 7, 15 ou 30. */
    validadeDias: number;
    email: string;
    nomeDestinatario: string | null = null;
    /** Ausente = o servidor monta ("Orçamento nº 3 — Empresa"). */
    assunto: string | null = null;
    mensagem: string;
}
